import styled from 'styled-components'

import Icon from 'components/icons'
import mediaQueries from 'components/media-queries'
import e2eClasses from 'constants/e2eClasses'

export const FlightContainer = styled.div`
  display: flex;
  align-items: flex-start;
  ${({ hidden }) => (hidden ? `display:none;` : `display: flex;`)}
  ${mediaQueries.tablet`
    flex-direction: column;
    & > form {
      width: 100%;
    }
  `};
`

export const FormWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  ${mediaQueries.tablet`
    ${({ flightStatusPage }) =>
      flightStatusPage
        ? `
    align-items: baseline;`
        : `flex-direction: column;`}
  `}

  ${mediaQueries.mobile`
    flex-direction: column;
    ${({ flightStatusPage, theme }) =>
      flightStatusPage &&
      `padding: 0 20px;
  background-color: ${theme.colors.grayLighter};
    `}
  `}
`

export const Content = styled.div.attrs(() => ({
  className: e2eClasses.searchBox.statusBox
}))`
  flex-direction: column;
  display: flex;
  width: 100%;

  ${mediaQueries.tablet`
    width: ${({ fullwidth }) => (fullwidth ? '100' : '90')}%;
    ${({ flightStatusPage }) =>
      flightStatusPage &&
      `
        padding: 20px 50px;
      `};
  `};
  ${mediaQueries.mobile`
     ${({ flightStatusPage, theme }) =>
       flightStatusPage &&
       `
        display: flex;
        background-color: ${theme.colors.grayLighter};
      `};
   `};
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ error }) => (error ? '30px' : '0')};
  width: ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? '340px'
      : '195px'};

  ${mediaQueries.tablet`
    width: 400px;
    &:first-child {
    padding: 25px 0 32px;
    }
  `};
  ${mediaQueries.mobile`
    width: 100%;
  `};

  .DayPickerInput {
    padding: 1px;
  }
`

export const Separator = styled.div`
  width: 30px;
`

export const IconWithMargin = styled(Icon)`
  margin: 9px 0 0 8px;
`

export const Label = styled.label.attrs(props => ({
  className: props.e2eClass
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  padding: 14px 0;
  color: ${({ theme }) => theme.colors.doveGray};
  ${mediaQueries.tablet/*Hides visually but not for screen-readers*/ `
    clip: rect(0 0 0 0); 
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap; 
    width: 1px;
  `};
`

export const Button = styled.button.attrs(() => ({
  className: e2eClasses.searchBox.statusConsultButton
}))`
  background-color: ${({ theme }) => theme.colors.blue};
  border: none;
  border-radius: 3px;
  color: ${({ theme }) => theme.colors.white};
  padding: 15px 30px;
  font-size: 16px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  outline: none;
  cursor: pointer;
  margin-bottom: 0;
  width: 100%;

  ${mediaQueries.mobile`
    padding: 10px 30px;
    margin-bottom: 20px;
  `};
`

export const RadioGroupContainer = styled.div`
  margin: 10px 0;
${({ hidden }) => (hidden ? `display:none;` : `display: flex;`)}
  ${mediaQueries.tablet`
    margin: 0;
    margin-top: 16px;
  `}

  ${mediaQueries.mobile`
    ${({ mobileSearchBox, theme }) =>
      mobileSearchBox &&
      `
      background: ${theme.colors.grayLighter};
      padding: 0 15px;
      margin: 0;
    `}
  `};
`
export const ButtonContainer = styled.div`
  display: flex;
  padding-top: 45px;
  width: 237px;

  ${mediaQueries.tablet`
    width: 400px;
  `};
  ${mediaQueries.mobile`
    width: 100%;
  `};
`

export const AirportContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true'
      ? '340px'
      : '195px'};

  ${mediaQueries.tablet`
    width: 400px;
    &:first-child {
    padding-top: 25px;
    }
    padding-bottom: 32px;
  `};
  ${mediaQueries.mobile`
    width: 100%;
  `};
`

export const SwapFieldsWrapper = styled.div`
  padding-top: 50px;
  ${mediaQueries.tablet`
    ${({ flightStatusPage }) => (flightStatusPage ? `align-self: end;` : `display: none;`)}
  `};
  ${mediaQueries.mobile`
    display: none;
  `};
`

export const Title = styled.label`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  text-align: left;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 10px;
`

export const MobileContainer = styled.div`
  display: flex;
  height: 60px;
  justify-content: space-between;
  padding: 15px 20px;
  background-color: ${({ theme }) => theme.colors.grayLighter};
  width: 100vw !important;
  margin-left: calc(50% - 50vw);
`

export const DashedSeparator = styled.div`
  border-bottom: 1px dashed ${({ theme }) => theme.colors.gray60};
  padding: 16px;
  ${({ expanded }) => !expanded && `display: none`};
`

export const FlightNumberTitle = styled.span`
  font-size: 18px;
  font-family: ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.blue};
`

export const Text = styled.span`
  font-size: 14px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.gray60};
`

export const Column = styled.div`
  display: flex;

  ${mediaQueries.mobile`
    background-color: ${({ theme }) => theme.colors.grayLighter};
  `};
`

export const DateContainer = styled.div`
  padding: 0 2px 10px 2px;
  align-items: flex-end;
  display: flex;
`

export const TextContainer = styled.div`
  display: flex;
  padding: 0 0 0 5px;
`

export const IconContainer = styled.div`
  align-items: center;
  display: flex;
`

export const Line = styled.div`
  border-bottom: 1px dashed ${({ theme }) => theme.colors.doveGray};
  margin: 0 15px;
`
